import { Component, Input } from '@angular/core';
import { AdditionalDetails } from '../../../Model/cost-calculation/CostCalculationVM';

@Component({
  selector: 'app-display-details',
  templateUrl: './display-details.component.html',
  styleUrl: './display-details.component.scss'
})
export class DisplayDetailsComponent {
  @Input() data?: AdditionalDetails;
  @Input() OnlyValue: boolean = false;

  ClacAdditions(width?: number, height?: number, price?: number) {
    return (width ?? 0) * (height ?? 0) * (price ?? 0);
  }

}
